import { defineStore } from 'pinia'

export const useOnboardingStore = defineStore('onboarding', {
  state: () => ({
    // tmp. user model
    // @property {string} user.first_name      - first name
    // @property {string} user.last_name       - last name
    // @property {string} user.email           - email
    // @property {string} user.password        - password
    // @property {object} user.user_agreements - user agreements (for RODO)
    // more: docs#!/business_api/service_business_account_BusinessAccountCreateHandler_post
    user: {},

    // tmp. business model
    // @property {string} business.name        - name
    // @property {string} business.subdomain   - subdomain
    // @property {object} business.location    - location
    // @property {object} business.type        - type
    // more: docs#!/business_api/service_business_create_MyBusinessesHandler_post
    business: {},

    // force full onboarding process
    forcedFullProcess: false,

    // after user clicks on sign up tab, we set it to true for future usage of go back logic
    isSignUpTabSelected: false,

    // data related to theSpace feature
    theSpace: null,

    activationDelay: null,

    // pending venue from Google Places for venue flow
    pendingVenue: null,
  }),

  actions: {
    reset () {
      this.user = {}
      this.business = {}
      this.forcedFullProcess = false
      this.isSignUpTabSelected = false
      this.theSpace = null
      this.activationDelay = null
      this.pendingVenue = null
    },

    updateUser (data) {
      Object.assign(this.user, data)
    },

    updateBusiness (data) {
      Object.assign(this.business, data)
    },

    setPendingVenue (venue) {
      this.pendingVenue = venue
    },

    clearPendingVenue () {
      this.pendingVenue = null
    },
  },
})
